import {useQuery} from "react-query";

import {PccService} from "../services/PccService";

export const useHasPccActivityLog = (
  facilityId: string | undefined,
  isPccEnabled: boolean | undefined,
) => {
  const {data} = useQuery(
    ["pcc-activity-log-exists", facilityId],
    async () => {
      const response = await PccService.get({facilityId, page: 0, size: 1});
      return response.data ?? [];
    },
    {enabled: !!facilityId && isPccEnabled !== true},
  );

  return (data?.length ?? 0) > 0;
};
